window.addEventListener('load', () => {
    const ATags = document.querySelectorAll('a:not([data-no-preload])');
    const preloadedElements: string[] = [];
    const preloadedLinks: Map<string, HTMLLinkElement> = new Map();

    let preLoadableTags: number = 0;

    ATags.forEach((a) => {
        const href = a.getAttribute('href');
        const nonAllowedHrefs = [
            '#',
            'mailto:',
            'tel:',
            'javascript:',
            '.test/',
        ]

        if (!href || nonAllowedHrefs.some((nonAllowedHref) => href?.indexOf(nonAllowedHref) != -1) ||
            window.location.host.endsWith('.test') && href?.indexOf('/') == 0 ||
            a.getAttribute('target') == "_blank"
        ) {
            return;
        }

        if (href.indexOf('http') == -1) {
            if (href.indexOf('/') != 0) {
                return;
            } else {
                a.setAttribute('href', 'https://' + window.location.host + href);
            }
        }

        preLoadableTags++;

        a.addEventListener('mouseenter', () => {
            if (preloadedElements.indexOf(href) != -1) {
                return;
            }

            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = href;
            document.head.appendChild(link);
            preloadedElements.push(href);
            preloadedLinks.set(href, link);
        });

        a.addEventListener('mouseleave', () => {
            if (preloadedElements.indexOf(href) != -1) {
                const link = preloadedLinks.get(href);
                if (link) {
                    document.head.removeChild(link);
                    preloadedElements.splice(preloadedElements.indexOf(href), 1);
                    preloadedLinks.delete(href);
                }
            }
        });
    });
});